import * as yup from "yup";

export const SocietyOnboardingScheama = yup.object().shape({
  societyName: yup.string().required("required"),
  phone: yup.string().required("required"),
  farmerId: yup.number(),
  addressLine1: yup.string().required("required"),
  addressLine2: yup.string(),
  city: yup.string().required("required"),
  state: yup.string().required("required"),
  pincode: yup.string(),
  country: yup.string(),
  numofPeopleSize: yup.number(),
});
